import React from 'react';
import {FaWhatsapp} from 'react-icons/fa';
import {Container} from "./styles";
import {handleWhatsAppClick} from "../../utils/suport";

const WhatsAppButton = () => {

    return (
        <Container onClick={() => {
          handleWhatsAppClick();
        }}>
            <FaWhatsapp size={32} />
        </Container>
    );
};

export default WhatsAppButton;
